import * as z from "zod";

export const confirmAeoAssistantTool = {
  name: "confirmAeoAssistantTool" as const,
  input: z.object({
    threadId: z.string(),
    toolCallId: z.string(),
    confirmed: z.boolean(),
  }),
  output: z.object({ success: z.boolean() }),
};
